import { TaxMode } from './tax-mode';
/**
 * The default monetary value configuration.
 */
export const defaultMonetaryValueConfig = {
    taxMode: TaxMode.Inclusive
};
//# sourceMappingURL=monetary-value.js.map